import { useState } from 'react';
import { SkillsColumns } from '../SkillsColumns';
import styles from './CategoriesAndSkillsMobile.module.css';

interface CategoryItem {
  label: string;
  href?: string;
  active?: boolean;
}

interface SkillColumn {
  title: string;
  skills: string[];
}

interface CategoriesAndSkillsMobileProps {
  items: CategoryItem[];
  skills: SkillColumn[][];
}

export const CategoriesAndSkillsMobile: React.FC<
  CategoriesAndSkillsMobileProps
> = ({ items, skills }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  function onClick(index: number) {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  }

  return (
    <div className={styles.categoriesAndSkillsMobileContainer}>
      {items.map((item: CategoryItem, index: number) => {
        const isCurrentOpen = activeIndex === index;

        return (
          <div
            key={item.label}
            className={`${styles.categoryItemContainer} ${index === items.length - 1 ? styles.last : ''}`}
          >
            <div className={styles.categoryItemSelector}>
              <p className={styles.label}>{item.label}</p>
              <p className={`${styles.button}`} onClick={() => onClick(index)}>
                {isCurrentOpen ? 'view less' : 'view more'}
              </p>
            </div>

            <div className={`${isCurrentOpen ? styles.open : styles.close}`}>
              <SkillsColumns columns={skills[index] || []} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
